/* Galerie Shopify: delegare de evenimente pentru sectiuni adaugate din Customize. */
(function () {
  'use strict';
  if (window.__gnAboutEducationBound) return;
  window.__gnAboutEducationBound = true;

  function selectSlide(section, requestedIndex) {
    var slides = Array.prototype.slice.call(section.querySelectorAll('[data-gn-edu-slide]'));
    var thumbs = Array.prototype.slice.call(section.querySelectorAll('[data-gn-edu-thumb]'));
    if (!slides.length) return;
    var index = ((requestedIndex % slides.length) + slides.length) % slides.length;

    slides.forEach(function (slide, i) {
      var active = i === index;
      slide.hidden = !active;
      slide.setAttribute('aria-hidden', active ? 'false' : 'true');
    });
    thumbs.forEach(function (thumb, i) {
      thumb.setAttribute('aria-current', i === index ? 'true' : 'false');
    });
    var status = section.querySelector('[data-gn-edu-status]');
    if (status) status.textContent = 'Fotografia ' + (index + 1) + ' din ' + slides.length;

    var list = section.querySelector('.gn-about-education__thumbnails');
    var activeThumb = thumbs[index];
    if (list && activeThumb) {
      var listBox = list.getBoundingClientRect();
      var thumbBox = activeThumb.getBoundingClientRect();
      if (thumbBox.left < listBox.left) {
        list.scrollLeft += thumbBox.left - listBox.left - 4;
      } else if (thumbBox.right > listBox.right) {
        list.scrollLeft += thumbBox.right - listBox.right + 4;
      }
    }
  }

  function getCurrent(section) {
    var thumbnails = Array.prototype.slice.call(section.querySelectorAll('[data-gn-edu-thumb]'));
    var index = thumbnails.findIndex(function (thumb) {
      return thumb.getAttribute('aria-current') === 'true';
    });
    return index < 0 ? 0 : index;
  }

  document.addEventListener('click', function (event) {
    if (!event.target.closest) return;
    var control = event.target.closest('[data-gn-edu-thumb], [data-gn-edu-prev], [data-gn-edu-next]');
    if (!control) return;
    var section = control.closest('.gn-about-education');
    if (!section) return;
    var nextIndex = getCurrent(section);
    if (control.hasAttribute('data-gn-edu-thumb')) {
      nextIndex = parseInt(control.getAttribute('data-gn-edu-index'), 10);
    } else if (control.hasAttribute('data-gn-edu-prev')) {
      nextIndex -= 1;
    } else {
      nextIndex += 1;
    }
    selectSlide(section, nextIndex);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
    if (!event.target.closest) return;
    var thumb = event.target.closest('[data-gn-edu-thumb]');
    if (!thumb) return;
    var section = thumb.closest('.gn-about-education');
    if (!section) return;
    var thumbs = Array.prototype.slice.call(section.querySelectorAll('[data-gn-edu-thumb]'));
    if (!thumbs.length) return;
    var nextIndex = (thumbs.indexOf(thumb) + (event.key === 'ArrowRight' ? 1 : -1) + thumbs.length) % thumbs.length;
    event.preventDefault();
    selectSlide(section, nextIndex);
    thumbs[nextIndex].focus();
  });

  document.addEventListener('shopify:block:select', function (event) {
    if (!event.target.closest) return;
    var thumb = event.target.closest('[data-gn-edu-thumb]') || event.target.querySelector('[data-gn-edu-thumb]');
    if (!thumb) return;
    var section = thumb.closest('.gn-about-education');
    if (section) selectSlide(section, parseInt(thumb.getAttribute('data-gn-edu-index'), 10));
  });
}());
